import { Injectable } from '@angular/core';
import { EPlatformFeature } from '@enums/campaign.enum';
import { IAnalyticsNode, ICampaignAnalytics } from '@interfaces/campaign-analytics.interface';
import { camelCase } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class CampaignDetailsPlatformFeaturesService {
  public getExistingPlatformFeatures(analyticsNodes: IAnalyticsNode[]): Set<EPlatformFeature> {
    const platformFeatures: Set<EPlatformFeature> = new Set();

    analyticsNodes.forEach((analyticsNode) => {
      platformFeatures.add(camelCase(analyticsNode.platformFeature) as EPlatformFeature);
    });

    return platformFeatures;
  }

  public getCampaignPlatformFeatures(campaignAnalytics: ICampaignAnalytics): Set<EPlatformFeature> {
    const platformFeatures: Set<EPlatformFeature> = new Set();

    campaignAnalytics.creators.forEach((creator) => {
      creator.plannedCtas.forEach((plannedCta) => {
        platformFeatures.add(camelCase(plannedCta.platformFeature) as EPlatformFeature);
      });
    });

    return platformFeatures;
  }
}
